import { useCallback, useEffect, useState } from 'react';
import { getApiErrorMessage } from '../../subscriptionAdmin/api';

/**
 * Loads async data on mount. Pass a memoized fetchFn (useCallback).
 */
export function useAdminFetch(fetchFn) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await fetchFn();
      setData(result);
      return result;
    } catch (err) {
      setError(getApiErrorMessage(err));
      setData(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [fetchFn]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load, setData };
}
